/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest =
  {
    ledgerCanisterId: string;
    start?: number | undefined;
    end?: number | undefined;
  };

/** @internal */
export const ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$inboundSchema:
  z.ZodType<
    ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$Outbound =
  {
    ledger_canister_id: string;
    start?: number | undefined;
    end?: number | undefined;
  };

/** @internal */
export const ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$outboundSchema:
  z.ZodType<
    ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$Outbound,
    z.ZodTypeDef,
    ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$ {
  /** @deprecated use `ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$inboundSchema;
  /** @deprecated use `ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$outboundSchema;
  /** @deprecated use `ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$Outbound` instead. */
  export type Outbound =
    ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$Outbound;
}

export function listTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequestToJSON(
  listTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest:
    ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest,
): string {
  return JSON.stringify(
    ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$outboundSchema
      .parse(
        listTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest,
      ),
  );
}

export function listTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest' from JSON`,
  );
}
